// components/auth/UserInfo.tsx
import { Badge } from "@/components/ui/badge";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const UserInfo = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <div className="flex flex-col space-y-1">
      <p className="text-sm font-medium leading-none">{user?.name || 'User'}</p>
      <p className="text-xs leading-none text-muted-foreground">
        {user?.email || ''}
      </p>
      {user?.userType && (
        <Badge variant="secondary" className="mt-1 w-fit text-xs">
          {user.userType}
        </Badge>
      )}
    </div>
  );
};
